import type { LoadingArea } from "@/stores/useLoadingStore"

const useLoading = (target: LoadingArea) => {
  const loadingStore = useLoadingStore()

  const { load, unload, reset } = loadingStore

  const mapCount = computed(() => loadingStore.mapCount)
  const isLoading = computed(() => !!(mapCount.value.get(target) || 0))

  return {
    isLoading,
    load: () => load(target),
    unload: () => unload(target),
    reset: () => reset(target)
  }
}

export default useLoading
